var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.854 11.1462L18.6457 12.5421C18.229 12.8025 17.6978 12.74 17.354 12.3962L12.6353 7.67751C12.2915 7.33376 12.229 6.80251 12.4895 6.38584L13.8853 4.17751C14.7395 2.83376 16.4478 2.77126 17.7082 4.02126L21.0207 7.33376C22.1874 8.51084 22.1145 10.3442 20.854 11.1462Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3236 20.7809L6.2403 21.8434C6.15939 21.8541 6.07952 21.8617 6.00077 21.8664C5.28709 21.9085 5.11015 21.0672 5.61567 20.5617L8.31322 17.8642C8.64655 17.5413 8.64655 17.0309 8.31322 16.708C8.00072 16.385 7.4903 16.385 7.15697 16.708L4.45942 19.4055C3.9539 19.911 3.12043 19.7333 3.15836 19.0194C3.16233 18.9444 3.16879 18.8684 3.1778 18.7913L4.25072 9.70791C4.52155 7.43708 5.35489 6.68708 7.75072 6.83291L9.31322 6.92666C9.82364 6.95791 10.3028 7.17666 10.6673 7.54124L17.4903 14.3642C17.8548 14.7288 18.0736 15.208 18.0944 15.7184L18.1882 17.2809C18.4278 19.6871 17.6048 20.5205 15.3236 20.7809Z",
    fill: "#292D32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureIcon);
export default __webpack_public_path__ + "static/media/signature-icon.421ae10ab9fd771a820419ac8f7b394c.svg";
export { ForwardRef as ReactComponent };